export enum SearchSubErrorCode {
    SUPPLIER_ERROR = 'SUPPLIER_ERROR',
    SUPPLY_ERROR = 'SUPPLY_ERROR',
    BLOCKED_FLOW = 'BLOCKED_FLOW',
    PRICING_CALCULATION_ERROR = 'PRICING_CALCULATION_ERROR',
    GOOGLE_ERROR = 'GOOGLE_ERROR',
    LOYALTY_INSUFFICIENT_BALANCE_ERROR = 'LOYALTY_INSUFFICIENT_BALANCE_ERROR',
    LOYALTY_ERROR = 'LOYALTY_ERROR',
    RANKING_ERROR = 'RANKING_ERROR',
    INVALID_DATA = 'INVALID_DATA',
    MISSING_FIELDS = 'MISSING_FIELDS',
    UNSUPPORTED_LOCALE = 'UNSUPPORTED_LOCALE',
    BAD_REQUEST = 'BAD_REQUEST',
    GEO_LOOKUP_NOT_FOUND = 'GEO_LOOKUP_NOT_FOUND',
    EXCHANGE_RATE_NOT_FOUND = 'EXCHANGE_RATE_NOT_FOUND',
    TRANSFORM_ERROR = 'TRANSFORM_ERROR',
    NO_RESULTS_FOUND = 'NO_RESULTS_FOUND',
    PARTIAL_CONTENT = 'PARTIAL_CONTENT',
    EMPTY_SUB_ERROR_CODE = 'EMPTY_SUB_ERROR_CODE',
    UNCATEGORIZED = 'UNCATEGORIZED',
}
